// import { makeAutoObservable } from 'mobx'
import React from 'react'
import { runInAction } from 'mobx'

import { BaseStoreType } from 'stores/base_store';
import { BioProps, BioStore } from './bio_store';
import { CalendarAuthType, CalendarAuthStore } from './calendar_auth_store';
import { CalendarEventType, CalendarEventStore } from './calendar_event_store';
import { CallIncomingType, CallIncomingStore } from 'stores/call_incoming_store';
import { CallParticipantProps, CallParticipantStore } from './call_participant_store';
import { CallProps, CallStore } from './call_store';
import { ChatRoomType, ChatRoomStore } from './chat_room_store';
import { ClockProps, ClockStore } from './clock_store';
import { CollabInviteStore, CollabInviteProps } from './collab_invite_store';
import { CollabProps, CollabStore } from './collab_store';
import { CollaboratorsProps, CollaboratorsStore } from './collaborators_store';
import { CommentsStore } from './comments_store'
import { ConvoStore } from './convo_store'
import { CreditLogProps, CreditLogStore } from './credit_log_store';
import { DedicatedAssignmentProps, DedicatedAssignmentStore } from 'stores/dedicated_assignment_store';
import { DeviceStore } from 'stores/device_store';
import { EmailProps, EmailStore } from 'stores/email_store';
import { FHRequestAttachmentStore } from 'stores/fhrequest_attachment_store';
import { FHRequestMessageType, FHRequestMessageStore } from 'stores/fhrequest_message_store';
import { FHRequestType, FHRequestStore } from 'stores/fhrequest_store';
import { RequestDelayType, RequestDelayStore } from 'stores/request_delay_store';
import { FileAssociationType, FileAssociationStore } from 'stores/file_association_store';
import { FileType, FileStore } from 'stores/file_store';
import { IdentityStore, IdentityProps } from './identity_store'
import { IncomingPhoneNumberType, IncomingPhoneNumberStore } from './incoming_phone_number_store'
import { InfoType, InfoStore } from './info_store'
import { LoreType, LoreStore } from 'stores/lore_store';
import { MessageProps } from './messages_store';
import { MessagesStore } from './messages_store'
import { MutualProps, MutualStore } from './mutual_store'
import { PaymentProps, PaymentStore } from 'stores/payment_store';
import { ProjectProps, ProjectStore } from './project_store'
import { RatingType, RatingStore } from 'stores/rating_store';
import { RoleStore } from './role_store'
import { ShiftHistoryStore, ShiftHistoryType } from './shift_history_store'
import { SortableStore, SortableType } from './sortable_store';
import { SubscriptionType, SubscriptionStore } from 'stores/subscription_store';
import { UserCollaboratorsStore } from './user_collaborators_store';
import { UserIdentityStore } from './user_identity_store'
import { UserProps, UserStore } from './user_store'
import { TeamType, TeamStore } from './team_store'
import { TeamInviteType, TeamInviteStore } from 'stores/team_invite_store';

type TransportLayerUpdateFunctionType = (obj : TransportLayerUpdateType) => void;

export interface IDListType {
	[key: string]: TransportLayerUpdateFunctionType[];
}

export type TransportLayerUpdateType =
    BioProps | BioProps[] |
    CalendarAuthType | CalendarAuthType[] |
    CalendarEventType | CalendarEventType[] |
    CallIncomingType | CallIncomingType[] |
    CallParticipantProps | CallParticipantProps[] |
    CallProps | CallProps[] |
    ChatRoomType | ChatRoomType[] |
    ClockProps | ClockProps[] |
    CollabInviteProps | CollabInviteProps[] |
    CollabProps | CollabProps[] |
    CollaboratorsProps | CollaboratorsProps[] |
    CreditLogProps | CreditLogProps[] |
    DedicatedAssignmentProps | DedicatedAssignmentProps[] |
    EmailProps | EmailProps[] |
    FHRequestMessageType | FHRequestMessageType[] |
    FHRequestType | FHRequestType[] |
    FileAssociationType | FileAssociationType[] |
    FileType | FileType[] |
    IdentityProps | IdentityProps[] |
    IncomingPhoneNumberType | IncomingPhoneNumberType[] |
    InfoType | InfoType[] |
    LoreType | LoreType[] |
    MessageProps | MessageProps[] |
    MutualProps | MutualProps[] |
    PaymentProps | PaymentProps[] |
    ProjectProps | ProjectProps[] |
    RatingType | RatingType[] |
    RequestDelayType | RequestDelayType[] |
    ShiftHistoryType | ShiftHistoryType[] |
    SortableType | SortableType[] |
    SubscriptionType | SubscriptionType[] |
    TeamType | TeamType[] |
    TeamInviteType | TeamInviteType[] |
    UserProps | UserProps[];


export type TransportLayerType = {
	listeners: IDListType,
	forwardUpdate: (type : string, payload : TransportLayerUpdateType) => void,
	onReceiveUpdate: (type: string, cb: (obj : TransportLayerUpdateType) => void) => void
}

const _listeners = {} as IDListType;
export const transportLayer = {
	listeners: _listeners,
	onReceiveUpdate(type : string, cb : (obj : TransportLayerUpdateType) => void) {
		if(!this.listeners[type]) {
			this.listeners[type] = [] as TransportLayerUpdateFunctionType[];
		}
		this.listeners[type].push(cb);
		// console.log("Listeners: %d", this.listeners[type].length);
	},
	forwardUpdate(type : string, payload : TransportLayerUpdateType) {
        // console.log("forwardUpdate() type: %o", type);
		// console.log("Listeners: %d", this.listeners[type].length);
		this.listeners[type].forEach( (cb : TransportLayerUpdateFunctionType) => {
			cb(payload);
		});
	}
}


export type RootStoreType = {
    bioStore: BioStore,
    calendarAuthStore: CalendarAuthStore,
    calendarEventStore: CalendarEventStore,
    callStore: CallStore,
    callIncomingStore: CallIncomingStore,
    callParticipantStore: CallParticipantStore,
    chatRoomStore: ChatRoomStore,
	clockStore: ClockStore,
	collabStore: CollabStore,
	commentsStore: CommentsStore,
	convoStore: ConvoStore,
    creditLogStore: CreditLogStore,
    dedicatedAssignmentStore: DedicatedAssignmentStore,
    deviceStore: DeviceStore,
    emailStore: EmailStore,
    fileStore: FileStore,
    fileAssociationStore: FileAssociationStore,
	identityStore: IdentityStore,
    incomingPhoneNumberStore: IncomingPhoneNumberStore,
    infoStore: InfoStore,
	messagesStore: MessagesStore,
    mutualStore: MutualStore,
	projectStore: ProjectStore,
	fhRequestStore: FHRequestStore,
    fhRequestMessageStore: FHRequestMessageStore,
    fhRequestAttachmentStore: FHRequestAttachmentStore,
	roleStore: RoleStore,
    shiftHistoryStore: ShiftHistoryStore,
    sortableStore: SortableStore,
	transportLayer: TransportLayerType
	userIdentityStore: UserIdentityStore,
	userStore: UserStore,
    collabInviteStore: CollabInviteStore,
    collaboratorsStore: CollaboratorsStore,
    subscriptionStore: SubscriptionStore,
    teamStore: TeamStore,
    teamInviteStore: TeamInviteStore,
    userCollaboratorsStore: UserCollaboratorsStore,
    paymentStore: PaymentStore,
    ratingStore: RatingStore,
    requestDelayStore: RequestDelayStore,
    loreStore: LoreStore
}


export interface ForwardsType { [key: string]: BaseStoreType }


export class RootStore implements RootStoreType {
    forwards = {} as ForwardsType
	transportLayer: TransportLayerType
    bioStore: BioStore
    calendarAuthStore: CalendarAuthStore
    calendarEventStore: CalendarEventStore
	callStore: CallStore
    callIncomingStore: CallIncomingStore
    callParticipantStore: CallParticipantStore
    chatRoomStore: ChatRoomStore
	clockStore: ClockStore
	collabStore: CollabStore
	commentsStore: CommentsStore
	convoStore: ConvoStore
    creditLogStore: CreditLogStore
    dedicatedAssignmentStore: DedicatedAssignmentStore
    deviceStore: DeviceStore
    emailStore: EmailStore
    fileStore: FileStore
    fileAssociationStore: FileAssociationStore
	identityStore: IdentityStore
    infoStore: InfoStore
    incomingPhoneNumberStore: IncomingPhoneNumberStore
	messagesStore: MessagesStore
    mutualStore: MutualStore
	projectStore: ProjectStore
    fhRequestStore: FHRequestStore
    fhRequestMessageStore: FHRequestMessageStore
    fhRequestAttachmentStore: FHRequestAttachmentStore
	roleStore: RoleStore
	userStore: UserStore
    collabInviteStore: CollabInviteStore
    collaboratorsStore: CollaboratorsStore
    shiftHistoryStore: ShiftHistoryStore
    sortableStore: SortableStore
    teamStore: TeamStore
    teamInviteStore: TeamInviteStore
    userCollaboratorsStore: UserCollaboratorsStore
    userIdentityStore: UserIdentityStore
    subscriptionStore: SubscriptionStore
    paymentStore: PaymentStore
    ratingStore: RatingStore
    requestDelayStore: RequestDelayStore
    loreStore: LoreStore

    constructor(transportLayer : TransportLayerType) {
		this.transportLayer = transportLayer

        this.bioStore = new BioStore(this, transportLayer);
        this.calendarAuthStore = new CalendarAuthStore(this, transportLayer);
        this.calendarEventStore = new CalendarEventStore(this, transportLayer);
        this.callStore = new CallStore(this, transportLayer);
        this.callIncomingStore = new CallIncomingStore(this, transportLayer);
        this.callParticipantStore = new CallParticipantStore(this, transportLayer);
        this.chatRoomStore = new ChatRoomStore(this, transportLayer);
        this.clockStore = new ClockStore(this, transportLayer);
        this.collabInviteStore = new CollabInviteStore(this, transportLayer);
        this.collabStore = new CollabStore(this, transportLayer);
        this.collaboratorsStore = new CollaboratorsStore(this, transportLayer);
        this.commentsStore = new CommentsStore(this, transportLayer)
        this.convoStore = new ConvoStore(this, transportLayer)
        this.creditLogStore = new CreditLogStore(this, transportLayer);
        this.dedicatedAssignmentStore = new DedicatedAssignmentStore(this, transportLayer);
        this.deviceStore = new DeviceStore(this, transportLayer);
        this.emailStore = new EmailStore(this, transportLayer);
        this.fileStore = new FileStore(this, transportLayer);
        this.fileAssociationStore = new FileAssociationStore(this, transportLayer);
        this.identityStore = new IdentityStore(this, transportLayer)
        this.incomingPhoneNumberStore = new IncomingPhoneNumberStore(this, transportLayer);
        this.infoStore = new InfoStore(this, transportLayer);
        this.messagesStore = new MessagesStore(this, transportLayer)
        this.mutualStore = new MutualStore(this, transportLayer)
        this.projectStore = new ProjectStore(this, transportLayer)
        this.fhRequestStore = new FHRequestStore(this, transportLayer);
        this.fhRequestMessageStore = new FHRequestMessageStore(this, transportLayer);
        this.fhRequestAttachmentStore = new FHRequestAttachmentStore(this, transportLayer);
        this.roleStore = new RoleStore(this, transportLayer)
        this.shiftHistoryStore = new ShiftHistoryStore(this, transportLayer);
        this.sortableStore = new SortableStore(this, transportLayer);
        this.teamStore = new TeamStore(this, transportLayer);
        this.teamInviteStore = new TeamInviteStore(this, transportLayer);
        this.loreStore = new LoreStore(this, transportLayer);
        this.userCollaboratorsStore = new UserCollaboratorsStore(this, transportLayer);
        this.userIdentityStore = new UserIdentityStore(this, transportLayer)
        this.userStore = new UserStore(this, transportLayer)
        this.subscriptionStore = new SubscriptionStore(this, transportLayer)
        this.paymentStore = new PaymentStore(this, transportLayer);
        this.ratingStore = new RatingStore(this, transportLayer);
        this.requestDelayStore = new RequestDelayStore(this, transportLayer);

        // listen for realtime updates from the server
        this.addForward("bio", this.bioStore as BaseStoreType);
        this.addForward("calendar_auth", this.calendarAuthStore as BaseStoreType);
        this.addForward("calendar_event", this.calendarEventStore as BaseStoreType);
        this.addForward("call", this.callStore as BaseStoreType);
        this.addForward("call_incoming", this.callIncomingStore as BaseStoreType);
        this.addForward("call_participant", this.callParticipantStore as BaseStoreType);
        this.addForward("chat_room", this.chatRoomStore as BaseStoreType);
        this.addForward("clock", this.clockStore as BaseStoreType);
        this.addForward("collab", this.collabStore as BaseStoreType);
        this.addForward("collab_invite", this.collabInviteStore as BaseStoreType);
        this.addForward("collaborators", this.collaboratorsStore as BaseStoreType);
        this.addForward("collaborators", this.userCollaboratorsStore as BaseStoreType);
        this.addForward("credit_log", this.creditLogStore as BaseStoreType);
        this.addForward("dedicated_assignment", this.dedicatedAssignmentStore as BaseStoreType);
        this.addForward("email", this.emailStore as BaseStoreType);
        this.addForward("file", this.fileStore as BaseStoreType);
        this.addForward("file_association", this.fileAssociationStore as BaseStoreType);
        this.addForward("identity", this.identityStore as BaseStoreType);
        this.addForward("incoming_phone_number", this.incomingPhoneNumberStore as BaseStoreType);
        this.addForward("info", this.infoStore as BaseStoreType);
        this.addForward("message", this.messagesStore as BaseStoreType);
        this.addForward("mutual", this.mutualStore as BaseStoreType);
        this.addForward("payment", this.paymentStore as BaseStoreType);
        this.addForward("project", this.projectStore as BaseStoreType);
        this.addForward("rating", this.ratingStore as BaseStoreType);
        this.addForward("request", this.fhRequestStore as BaseStoreType);
        this.addForward("request_delay", this.requestDelayStore as BaseStoreType);
        this.addForward("request_message", this.fhRequestMessageStore as BaseStoreType);
        this.addForward("shift_history", this.shiftHistoryStore as BaseStoreType);
        this.addForward("sortable", this.sortableStore as BaseStoreType);
        this.addForward("lore", this.loreStore as BaseStoreType);
        this.addForward("user", this.userStore as BaseStoreType);
        this.addForward("user_identity", this.userIdentityStore as BaseStoreType);
        this.addForward("team", this.teamStore as BaseStoreType);
        this.addForward("team_invite", this.teamInviteStore as BaseStoreType);

    }

    addForward(dataMetaType: string, store: BaseStoreType) {
        store.transportLayer.onReceiveUpdate(dataMetaType, (data: TransportLayerUpdateType) => {
            runInAction(() => {
                const debugging = dataMetaType === "clock" ? true : false;
                // console.log("dataMetaType: %s, debugging: %o", dataMetaType, debugging);
                store.receiveUpdate(data, debugging)
            });
        });
        this.forwards[dataMetaType] = store;
    }

	forwardUpdate(dataMetaType: string, payload: TransportLayerUpdateType) {
        // console.log("forwarding update, this is our sitch: %o", Object.keys(this.forwards));
        if(Object.keys(this.forwards).indexOf(dataMetaType) > -1) {
            // console.log("forwardUpdate() forwarding %s", dataMetaType);
            this.forwards[dataMetaType].transportLayer.forwardUpdate(dataMetaType, payload);
        } else {
            console.error("Unhandled update dataMetaType: %s", dataMetaType);
        }
	}

}

export const RootStoreContext = React.createContext( new RootStore(transportLayer) );
